import styled from 'styled-components';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Badge,
  IconButton,
  IconButtonProps,
  PopoverButton,
  Tooltip,
} from '@electricjs/arc';

const BadgeContainer = styled.div`
  position: relative;
`;

// Create a properly typed PopoverIconButton that accepts IconButton props
// We need to cast because PopoverButton's type doesn't properly infer the `as` prop's type
const PopoverIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return (
      <PopoverButton
        as={IconButton}
        ref={ref}
        {...(props as unknown as React.ComponentProps<typeof PopoverButton>)}
      />
    );
  }
);

PopoverIconButton.displayName = 'PopoverIconButton';

type NotificationButtonProps = {
  notificationsCount?: number;
};

const NotificationButton = ({
  notificationsCount = 0,
}: NotificationButtonProps) => {
  const { t } = useTranslation('common');
  return (
    <Tooltip content={t('topNav.notifications')} placement="bottom">
      <BadgeContainer>
        <PopoverIconButton
          id="notification-button"
          icon="alarm-bell"
          iconSize="medium"
        />
        <Badge
          size="1rem"
          position="absolute"
          top="0px"
          left="2.2rem"
          count={notificationsCount}
          hideCount={true}
        />
      </BadgeContainer>
    </Tooltip>
  );
};

export default NotificationButton;
